<template>
    <div class="device-config">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>设备参数</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="margin-top: 1rem; padding: 1.5rem 1rem 0 1rem; background-color: white">
            <el-form :inline="true">
                <el-form-item label="">
                        <el-input placeholder="" disabled style="width: 250px"></el-input>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import settingsApi from "../../api/settings";

    export default {
        name: "DeviceConfig",
        data: function () {
            return {
                ucKey: ""
            }
        },
        mounted: function() {
          this.getUckey();
        },
        methods: {
            getUckey: function () {
                this.ucKey = settingsApi.getUcKey().then(res => this.ucKey = res);
            }
        }
    }
</script>

<style scoped>

</style>
